import script from "./WithdrawRequests.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawRequests.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawRequests.vue?vue&type=style&index=0&id=3083449c&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3083449c"]])

export default __exports__